import { render, staticRenderFns } from "./FlightCertificate.vue?vue&type=template&id=0816cbe4&scoped=true&"
import script from "./FlightCertificate.vue?vue&type=script&lang=js&"
export * from "./FlightCertificate.vue?vue&type=script&lang=js&"
import style0 from "./FlightCertificate.vue?vue&type=style&index=0&id=0816cbe4&prod&lang=less&scoped=true&"
import style1 from "./FlightCertificate.vue?vue&type=style&index=1&id=0816cbe4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816cbe4",
  null
  
)

export default component.exports